<div class="empty-state-container" *ngIf="show">
    <img src="assets/images/noDataIcon.svg" alt="no data Icon" class="no-data-icon" />
    <p class="message">{{ 'noDataAvailable' | translate }}</p>
</div>
